module.exports = __webpack_public_path__ + "static/img/img02_ng.e930141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv021/img02_ng.jpg
// module id = mc9R
// module chunks = 0